import { InjectionToken } from '@angular/core';
import { SelectOption } from '@nuso/forms/data-access';

export interface AppEnvironment {
  envName: string;
  production: boolean;
  sentry: string | null;
  showDebug: boolean;
  appName: string;
  statusPageIoEmbedUrl: string;
}

export interface PortalAppFeatures {
  customerTestingEnabled: boolean;
  nocEnabled: boolean;
  eFaxEnabled: boolean;
  ordersEnabled: boolean;
  cdrReportingEnabled: boolean;
  billingEnabled: boolean;
  portingEnabled: boolean;
  supportEnabled: boolean;
  liveTeamworkSupportEnabled: boolean;
  salesforceSupportEnabled: boolean;
  billableEventsEnabled: boolean;
  issuesEnabled: boolean;
  statusPageEnabled: boolean;
  numberMovingEnabled: boolean;
  bandwidthSyncingEnabled: boolean;
  commportalUrl: string;
  isTestDeleteMeta: boolean;
  bridgeZoomAuthUrl: string;
  // True until feat/microsoft-graph-backend is merged. While true, the Recording Sources
  // Policy Assignment tab uses hardcoded fixtures from
  // libs/recording/data-access/src/lib/azure-directory/azure-directory.mock.ts instead of
  // calling the real azureUsers / azureGroups GraphQL queries. Flip to false once the
  // upstream PR is live.
  useAzureDirectoryMock: boolean;

  supportedCustomerFeatures: string[];
  serviceOfferingOptions: SelectOption[];
  userRoleOptions: SelectOption[];
}

export interface PortalAppEnvironment extends AppEnvironment, PortalAppFeatures {
}

export const isProductionToken = new InjectionToken<boolean>('isProduction');
export const appEnvironmentToken = new InjectionToken<AppEnvironment>('appEnvironment');
export const portalAppFeaturesToken = new InjectionToken<PortalAppFeatures>('portalAppFeatures');